// eslint-disable-next-line no-shadow
enum ProducerReportType {
  CREDIT,
  DEBIT,
}
export default ProducerReportType;
